export default "__VITE_ASSET__DJRoltOV__"